var _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 230,
    height: 225,
    viewBox: "0 0 230 225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.012,
    cy: 1,
    r: 1.478,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#49ad3b",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#f18219",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2db9ca",
    stopOpacity: 0.169
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 230,
    height: 225,
    rx: 112.5,
    fill: "url(#radial-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle4);
export default __webpack_public_path__ + "static/media/circle4.04c3711fd1fca86531a79ccca272134d.svg";
export { ForwardRef as ReactComponent };